import React, {
  useState,
  useEffect,
} from 'react';
import PropTypes from 'prop-types';

import { stripesConnect } from '@folio/stripes/core';

import {
  DataFetcherContext,
} from '../components';

const initialContextData = {
  taskStatuses: [],
  taskStatusesLoaded: false,
  priorities: [],
  prioritiesLoaded: false,
  jobStatuses: [],
  jobStatusesLoaded: false,
};

const RootLayer = ({ children, mutator }) => {
  const [contextData, setContextData] = useState(initialContextData);

  const [taskStatuses, setTaskStatuses] = useState(initialContextData.taskStatuses);
  const [taskStatusesLoaded, setTaskStatusesLoaded] = useState(initialContextData.taskStatusesLoaded);

  const [priorities, setPriorities] = useState(initialContextData.priorities);
  const [prioritiesLoaded, setPrioritiesLoaded] = useState(initialContextData.prioritiesLoaded);

  const [jobStatuses, setJobStatuses] = useState(initialContextData.jobStatuses);
  const [jobStatusesLoaded, setJobStatusesLoaded] = useState(initialContextData.jobStatusesLoaded);

  useEffect(
    () => {
      let isSubscribed = true;

      mutator.taskStatuses.GET()
        .then(response => {
          if (isSubscribed) {
            setTaskStatuses(response.statuses);
            setTaskStatusesLoaded(true);
          }
        });

      mutator.priorities.GET()
        .then(response => {
          if (isSubscribed) {
            setPriorities(response.priorities);
            setPrioritiesLoaded(true);
          }
        });

      mutator.jobStatuses.GET()
        .then(response => {
          if (isSubscribed) {
            setJobStatuses(response.statuses);
            setJobStatusesLoaded(true);
          }
        });

      return () => {
        isSubscribed = false;
      };
    }, []
  );

  useEffect(
    () => {
      if (taskStatusesLoaded) {
        setContextData(cur => ({
          ...cur,
          taskStatuses,
          taskStatusesLoaded,
        }));
      }
    },
    [taskStatusesLoaded]
  );

  useEffect(
    () => {
      if (prioritiesLoaded) {
        setContextData(cur => ({
          ...cur,
          priorities,
          prioritiesLoaded,
        }));
      }
    },
    [prioritiesLoaded]
  );

  useEffect(
    () => {
      if (jobStatusesLoaded) {
        setContextData(cur => ({
          ...cur,
          jobStatuses,
          jobStatusesLoaded,
        }));
      }
    },
    [jobStatusesLoaded]
  );

  return (
    <DataFetcherContext.Provider value={contextData}>
      {children}
    </DataFetcherContext.Provider>
  );
};

RootLayer.manifest = Object.freeze({
  taskStatuses: {
    type: 'okapi',
    path: 'tasks/tasks-statuses',
    accumulate: 'true',
    fetch: false,
  },
  priorities: {
    type: 'okapi',
    path: 'tasks/priorities',
    accumulate: 'true',
    fetch: false,
  },
  jobStatuses: {
    type: 'okapi',
    path: 'tasks/jobs-statuses',
    accumulate: 'true',
    fetch: false,
  },
});

RootLayer.propTypes = {
  children: PropTypes.node.isRequired,
  mutator: PropTypes.shape({
    jobStatuses: PropTypes.shape({
      GET: PropTypes.func.isRequired,
    }),
    priorities: PropTypes.shape({
      GET: PropTypes.func.isRequired,
    }),
    taskStatuses: PropTypes.shape({
      GET: PropTypes.func.isRequired,
    }),
  }),
};

export default stripesConnect(RootLayer);
